export default function Logo({ size = 'md' }) {
  const shieldSize = size === 'lg' ? 'h-20 w-20' : 'h-12 w-12'
  const aegisSize = size === 'lg' ? 'text-3xl' : 'text-xl'
  const subSize = size === 'lg' ? 'text-xs' : 'text-[10px]'

  return (
    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
      <img
        src="/logo2.png"
        alt="Aegis Professional Services"
        className={`${shieldSize} object-contain flex-shrink-0`}
      />
      <div className="min-w-0">
        <div className={`${aegisSize} font-bold tracking-wider text-aps-red leading-none`}>
          AEGIS
        </div>
        <div className={`${subSize} font-semibold tracking-[0.15em] text-white uppercase whitespace-nowrap mt-0.5`}>
          Professional Services
        </div>
      </div>
    </div>
  )
}
